









































































































































































import skillbar from '@/components/skillbar.vue';
import SelectSearch from '@/components/select-search.vue';
import Apierrormessage from '@/components/Apierrormessage.vue';
import { ref, defineComponent, computed, onMounted } from '@vue/composition-api';
import store from '@/store';
import 'regenerator-runtime/runtime';
// import router from '@/router';
import validation from '@/data/validation.vue';
// import { bus } from '@/main';
import Vue from 'vue';

const bus = new Vue();

const defaultObjInit = () => ({
  skillId: '',
  name: '',
  skillMasterId: '',
  ratingDescription: '',
  addToMyPlan: false,
  description: '',
});

export default defineComponent({
  name: 'FunctionRole',
  components: {
    skillbar,
    SelectSearch,
    Apierrormessage,
    validation,
  },
  setup() {
    const selectedFunctions = ref([defaultObjInit()]);
    const selectedRoles = ref([defaultObjInit()]);
    const isChangeRole = ref(false);
    const isButtonCheck = ref(false);
    const renderReady = ref(false);
    const apiError = ref(false);
    const loading = ref(false);
    const computeOnce = ref(false);
    const showInfo = ref(false);
    const name = ref('');
    const infoType = ref('');
    onMounted(async () => {
      await store.dispatch('functions/getFunctions');
      await store.dispatch('profile/getEmployeeProfile');
      renderReady.value = true;
    });
    const skillsFunctions = computed(() => store.getters['functions/skillsFunctions']);
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const skillsRoles = computed(() => skillsFunctions.value?.filter((role: any) => role.skillId && selectedFunctions.value[0].skillId === role.skillId));
    const isNotNullAndUndefined = (key: any) => {
      if (key === null || key === undefined || key === '') {
        return false;
      }
      return true;
    };
    const showInfoModal = (type: any) => {
      bus.$emit('showInfoModal', type);
    };
    const proceedToNextPage = () => {
      bus.$emit('proceedToNextPage');
    };
    const proceedToNextTab = (path: any) => {
      if (!skillsEmployeeProfile.value.profileComplete && !skillsEmployeeProfile.value.isLegacy && !isChangeRole.value) {
        isButtonCheck.value = true;
        bus.$emit('proceedToNextPage', isChangeRole, isButtonCheck);
      } else if (isChangeRole.value) {
        // Denots only click on previous tab
        // @ts-ignore
        this.$router.push(path);
      }
    };
    const proceedButtonState = computed(() => isNotNullAndUndefined(selectedRoles.value[0].skillId));
    const employeeProfile: any = computed(() => {
      const userProfile = { ...skillsEmployeeProfile };
      /* eslint-disable */
      selectedFunctions.value = JSON.parse(JSON.stringify(userProfile.value?.function && userProfile.value?.function.length ? userProfile.value.function : [defaultObjInit()]));
      selectedRoles.value = JSON.parse(JSON.stringify(userProfile.value?.function[0].roles && userProfile.value?.function[0].roles.length ? userProfile.value.function[0].roles : [defaultObjInit()]));
      if (!computeOnce.value) {
        computeOnce.value = true;
      }
      return employeeProfile;
    });
    const inputValueChanged = (val: any, elem: any) => {
      // console.log('elem-----------------------', elem);
      // const { key } = elem.dataset;
      // const { id } = elem || {};
      const id = elem || {};
      if (id && id.includes('functions-select-')) {
        const index = parseInt(id.split('functions-select-')[1], 10);
        const obj = skillsFunctions.value?.find((x: any) => x.skillId === val.value);
        selectedFunctions.value[index].skillId = obj.skillId;
        selectedFunctions.value[index].name = obj.name;
        selectedFunctions.value[index].skillMasterId = obj.skillMasterId;
        selectedFunctions.value[index].ratingDescription = obj.ratingDescription || '';
        selectedRoles.value = [defaultObjInit()];
      } else if (id && id.includes('current-role-select-')) {
        isChangeRole.value = true;
        const index = parseInt(id.split('current-role-select-')[1], 10);
        const obj = skillsFunctions.value?.find((x: any) => x.skillId === selectedFunctions.value[index].skillId).roles?.find((y: any) => y.skillId === val.value);
        selectedRoles.value[index].skillId = obj.skillId;
        selectedRoles.value[index].name = obj.name;
        selectedRoles.value[index].skillMasterId = obj.skillMasterId;
        selectedRoles.value[index].description = obj.description;
        selectedRoles.value[index].ratingDescription = obj.ratingDescription || '';
        getIdealProfile(index);
      }
    };
    const getIdealProfile = (index: any) => {
      if(selectedFunctions.value[index].skillId && selectedRoles.value[index].skillId ) {
        const payload = JSON.parse(
        JSON.stringify({
        functionSkillId: encodeURIComponent(selectedFunctions.value[index].skillId),
        roleSkillId: encodeURIComponent(selectedRoles.value[index].skillId),
        }),
      );
        store.dispatch('idealProfile/getIdealProfile', { ...payload });
      }
    };
    return {
      selectedFunctions,
      selectedRoles,
      isChangeRole,
      loading,
      skillsFunctions,
      renderReady,
      apiError,
      inputValueChanged,
      computeOnce,
      skillsEmployeeProfile,
      skillsRoles,
      employeeProfile,
      proceedButtonState,
      proceedToNextPage,
      name,
      // router,
      validation,
      showInfo,
      infoType,
      showInfoModal,
      bus,
      proceedToNextTab,
      isButtonCheck,
    };
  },
});
